import { render } from "./Village.vue?vue&type=template&id=1c12e50c&scoped=true"
import script from "./Village.vue?vue&type=script&lang=js"
export * from "./Village.vue?vue&type=script&lang=js"

import "./Village.vue?vue&type=style&index=0&id=1c12e50c&scoped=true&lang=scss"

import exportComponent from "/builds/arena/frontend/game-maplestory-landing/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1c12e50c"]])

export default __exports__